import React from "react";
import { socialData } from "../../../../data/socialData";
import SocialCard from "../../../global/SocialCard";

export default function SocialsConfig() {
  return (
    <div className="w-full space-y-4 ">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {socialData.map((social, index) => (
          <SocialCard title={social.title} subtitle={social.subtitle} cardKey={index} imgPath={social.icon} link={'https://lucide.dev/icons/square-arrow-out-up-right'} />
        ))}
      </div>
    </div>
  );
}
